import { render, staticRenderFns } from "./SettingsBotsForm.vue?vue&type=template&id=7e8dfd25&"
import script from "./SettingsBotsForm.vue?vue&type=script&lang=js&"
export * from "./SettingsBotsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports